import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import TicketEditor from '@/routes/tickets/TicketEditor'
import { ticketEditorRouteLoader } from '@/routes/tickets/TicketEditor.route'
import { RoleRouteObject } from '@/types'

const TicketCreatorRoute = {
  path: 'new',
  element: <TicketEditor creating={true} />,
  loader: ticketEditorRouteLoader,
  allowedRoles: [Roles.Guest],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default TicketCreatorRoute
